<div class="regimes-list">
  <input-field
    [label]="'Filtrer'"
    [(value)]="filtreStr"
    [labelPosition]="'floating'"
    [type]="'text'"
    (changeEvent)="filter()"
  ></input-field>

  <ng-container *ngIf="listItems && listItems.length else noItems">
    <div class="regime-item" *ngFor="let item of listItems" (click)="selectItem(item)">
      <ng-container *ngFor="let libelleField of libelleFields">
        {{item[libelleField] + ' '}}
      </ng-container>
    </div>
  </ng-container>

  <ng-template #noItems>
    <ng-container *ngIf="listItems else loader">
      <div class="no-items">
        {{'selectLists.regimeAlimentaire.noItems' | translate}}
      </div>
    </ng-container>
  </ng-template>

  <ng-template #loader>
    <div class="loader">
      <ion-spinner name="crescent"></ion-spinner>
    </div>
  </ng-template>
</div>
